import Vue from 'vue';
import Vuetify from 'vuetify';
Vue.use(Vuetify);
export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#383f52',
                secondary: '#f3f8ff',
            },
        },
    },
});
